import React from 'react';

// DEPENDENCIES
import { capitalize } from 'lodash';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// LOCAL PARTS
import PageButtons from './PageButtons';
import PageView from './PageView';

// MAIN COMPONENT
const PageUpdate = ({
  children,
  label,
  title,
  method,
  endpoint,
  backPathname,
  buttons = (
    <PageButtons>
      <Button.Save />
    </PageButtons>
  ),
  buttonsBefore = false,
  buttonsAfter = true,
  headerTools,
  headerRight,
  fixedHeader,
  // REST
  ...props
}) => (
  <PageView
    title={title}
    headerTools={headerTools}
    headerRight={headerRight}
    backPathname={backPathname}
    fixedHeader={fixedHeader}
  >
    <Form
      method={method}
      endpoint={endpoint}
      loadingMessage={`Saving ${label}`}
      successMessage={`${capitalize(label)} saved.`}
      errorMessage={({ errors, message }) => errors?.length ? <ul className="ps-4">{errors.map(error => <li>{error}</li>)}</ul> : message || `Unable to save ${label}.`}
      {...props}
    >
      {buttonsBefore && buttons}
      {children}
      {buttonsAfter && buttons}
    </Form>
  </PageView>
);

// EXPORT
export default PageUpdate;
